import React from "react";
import { Link, useRouter } from "../../router";

// Top-level admin section switcher (Courses / Inquiries / Issues). Reuses
// the same `.tabs`/`.tab` look as the in-page tabs elsewhere in admin, but
// these are real links to separate routes rather than a same-page toggle.
export default function AdminSubNav({ active }) {
  const items = [
    { to: "/admin", key: "courses", label: "Courses" },
    { to: "/admin/inquiries", key: "inquiries", label: "Inquiries" },
    { to: "/admin/issues", key: "issues", label: "Issues" },
  ];
  return (
    <div className="tabs">
      {items.map((item) => (
        <Link key={item.key} to={item.to} className={`tab ${active === item.key ? "active" : ""}`}>
          {item.label}
        </Link>
      ))}
    </div>
  );
}
